import type { FileCategory, IFileItem } from "@/types/files";
import type { MaybeRef } from "vue";

interface IFilesListRequest {
  __limit?: number;
  order?: "asc" | "desc";
  sortBy?: "name" | "created";
  type?: FileCategory;
}

export function useFilesListRequest(query?: MaybeRef<IFilesListRequest>) {
  const enabled = computed(() => {
    const { type } = unref(query) || {};
    return !type || fileCategoryArr.includes(type);
  });
  const request = useInfiniteQuery({
    queryKey: ["files", "list", query],
    queryFn: async ({ pageParam }: { pageParam?: string | null }) => {
      const { data } = await useGetRequest<{ items: IFileItem[]; next?: string }>(
        "/account/files",
        {
          params: {
            type: unref(query)?.type,
            __limit: unref(query)?.__limit,
            order: unref(query)?.order || "desc",
            sortBy: unref(query)?.sortBy,
            nextQuery: pageParam || undefined,
          },
        }
      );
      if (!unref(query)?.sortBy) {
        data?.items?.sort(
          (a, b) => new Date(b.created).getTime() - new Date(a.created).getTime()
        );
      }

      if (!data?.items?.length) return null;
      return data || null;
    },
    staleTime: 3 * MINUTE,
    enabled,
    getNextPageParam: lastPage => lastPage?.next || null,
    initialPageParam: null,
    select: data =>
      (data?.pages
        .map(p => p?.items)
        .filter(Boolean)
        .flat() as IFileItem[]) || [],
  });
  return request;
}
